import React from 'react'
import VideosViewer from '../../../../components/VideosViewer'
import VideosUploaderField from '../../../../components/VideosUploaderField'
import { getEdit, getGroupModel, getModule } from '../../selectors'
import { getUser } from '../../../MainPage/selectors'
import { getFormValues } from 'redux-form'
import { OBJECT_FORM } from './Form'
import { connect } from 'react-redux'


const VideosContainer = props => {

    return (
        <div>
            <VideosViewer
                noThumbnail={props.field.noThumbnail}
                showArrows={props.field.showArrows ?? false}
                data={props.moduleData}
                accessId={props.accessId}
                groupModel={props.groupModel}
            />
            <VideosUploaderField
                {...props}
                module={props.module}
                user={props.user}
                accessId={props.accessId}
                groupModel={props.groupModel}
            />
        </div>
    )
}


const mapStateToProps = (state) => ({
    module: getModule(state),
    user: getUser(state),
    accessId: getEdit(state).accessId,
    groupModel: getGroupModel(state),
    moduleData: getFormValues(OBJECT_FORM)(state)
})

export default connect(mapStateToProps)(VideosContainer)
